<template>
    <div v-if="getGroup.bills.length > 0">
        <div v-if="getGroup.is_perk">
            <div v-for="bill in getGroup.bills" :key="bill.id"  class="bill-container" :class="{selected: getGroupSelected}" >
                <BillCardPerk :bill="bill" />
                 <div class="bill-checkmark"></div>
            </div>
        </div>

        <div v-else class="bill-container" :class="{selected: getGroupSelected}" >
            <BillBody :group="getGroup"></BillBody>
            <div class="bill-checkmark"></div>
        </div>
    </div>

</template>

<script>
    import BillBody from './BillBody';
    import BillCardPerk from './BillCardPerk';

    export default {
        name: "BillContainer",

        components: {
            BillBody,
            BillCardPerk
        },

        props: {
            group: {
                type: Number,
                required: true
            }
        },

        computed: {

            getGroupSelected() {
                return this.$store.getters['quote/getGroupSelected'](this.$props.group);
            },

            getGroup() {
                return this.$store.getters['quote/getGroupByID'](this.$props.group);
            }
        }
    }
</script>
